<div class="sera__filter-container">
    <div class="sera__filter-container__body">
        <div class="sera__filter-container__body__input-group">
            <ds-form-field>
                <ds-icon icon="search"></ds-icon>
                <input
                    ds-input
                    id="filterInput"
                    type="text"
                    class="sera__filter-container__body__input-group__input"
                    [(ngModel)]="filterValue"
                    placeholder="{{ 'PAGE.GENERAL.SEARCH.LBL' | translate }}" />
            </ds-form-field>
        </div>
        <div class="sera__filter-container__body__list">
            <ds-list-item
                class="sera__filter-container__body__list-item"
                *ngFor="let item of displayedItems"
                [variant]="'checkbox'"
                [isHoverable]="true"
                [isSelectable]="true"
                [isSelected]="item.selected"
                (isSelectedChange)="selectItem(item)"
                >{{ item.value }}</ds-list-item
            >
            <div
                class="sera__filter-container__body__list__empty-state"
                *ngIf="displayedItems.length === 0">
                <img
                    class="sera__filter-container__body__list__empty-state-image"
                    [src]="'assets/images/MM13/empty_table.png'"
                    [alt]="'GENERAL.NO_RESULTS.LBL' | translate" />
                <p class="sera__filter-container__body__list__empty-state-title_bold-text">{{ 'GENERAL.NO_RESULTS.LBL' | translate }}</p>
            </div>
        </div>
    </div>
</div>
